import { ActivityBuilderModal } from 'approot/activity-builder/activity-builder-modal';
import { NegativeButton } from 'approot/shared/styles/buttons';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import Text from 'approot/shared/styles/typography/text';

type PerformanceExpectationRemoveModalProps = {
  isVisible: boolean;
  isSaving?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const PerformanceExpectationRemoveModal = ({
  isVisible,
  isSaving,
  onClose,
  onConfirm,
}: PerformanceExpectationRemoveModalProps) => {
  return (
    <ActivityBuilderModal
      isVisible={isVisible}
      title="Are you sure?"
      headerTitle="Are you sure?"
      actions={
        <>
          <NegativeButton
            onClick={onConfirm}
            loading={isSaving}
            disabled={isSaving}
            data-testid="confirm-remove-outcome"
          >
            Yes, remove all
          </NegativeButton>
          <SecondaryButton
            onClick={onClose}
            data-testid="cancel-remove-outcome"
          >
            Cancel
          </SecondaryButton>
        </>
      }
      onClose={onClose}
    >
      <Text>
        Removing this performance expectation will also remove any dimensions
        linked to it.
      </Text>
    </ActivityBuilderModal>
  );
};

export default PerformanceExpectationRemoveModal;
